import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Common_Heading_Round_holder from "../common-components/common_Heading_Round_holder/Common_Heading_Round_holder";
import Product_card from "../common-components/product_card/Product_card";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import {
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";

const STEP = 4;
const categoryData = [
  {
    title: "Ghee",
    id: "ghee",
    products: [
      {
        imgSrc: "/assets/images/product/ghee.png",
        productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/ghee.png",
        productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },

      {
        imgSrc: "/assets/images/product/ghee.png",
        productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/ghee.png",
        productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
    ],
  },

  {
    title: "Kalanamak Rice",
    id: "rice",
    products: [
      {
        imgSrc: "/assets/images/product/rice.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/rice.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/rice.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/rice.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
    ],
  },

  {
    title: "Turmeric + Kali Haldi",
    id: "haldi",
    products: [
      {
        imgSrc: "/assets/images/sheared_Product/haldi.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/sheared_Product/haldi.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },

      {
        imgSrc: "/assets/images/sheared_Product/haldi.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/sheared_Product/haldi.png",
        productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
    ],
  },

  {
    title: "Desi Dal",
    id: "daal",
    products: [
      {
        imgSrc: "/assets/images/product/daal.png",
        productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/daal.png",
        productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/daal.png",
        productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
      {
        imgSrc: "/assets/images/product/daal.png",
        productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
        priceText: "200",
        kgText: "1",
        savingPrice: "20",
      },
    ],
  },
];

function Categories() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const [swiperInstance, setSwiperInstance] = useState(null);

  // const categoryWiseProduct = useSelector(
  //   (state) => state.product.allProductsGroup,
  // );

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Categories", link: "", isActive: true },
  ];



  const categoryId = queryParams.get("category_id");

  const category = useSelector((state) => state.master.categories);
  const subcategories = useSelector((state) => state.master.subcategories);
  const all_products = useSelector((state) => state.product.allProducts);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");

  /* ---------- CATEGORY CLICK ---------- */
  const handleCategoryClick = (category_id) => {
    if (!category_id) return;

    setSelectedCategoryId(category_id);
    dispatch(getAllSubCategory({ category_id }));
  };

  /* ---------- SUBCATEGORY CLICK ---------- */
  const handleSubCategoryClick = (category_id, subcategory_id) => {
    if (!subcategory_id) return;

    setSelectedSubCategoryId(subcategory_id);

    dispatch(
      getAllProducts({
        category_id,
        subcategory_id,
      }),
    );
  };

  useEffect(() => {
    if (!category?.length) return;

    // If URL category exists → use it, else first category
    const initialCategoryId = categoryId || category[0]?.id;

    if (initialCategoryId) {
      handleCategoryClick(initialCategoryId);
    }
  }, [category, categoryId]);

  useEffect(() => {
    if (!subcategories?.length || !selectedCategoryId) return;

    handleSubCategoryClick(selectedCategoryId, subcategories[0].id);
  }, [subcategories]);


  // const [visibleCounts, setVisibleCounts] = useState([]);

  // // Scroll to a specific category section when "See Less" is clicked
  // const handleToggle = (index, totalProducts, categoryId) => {
  //   setVisibleCounts((prevCounts) => {
  //     const newCounts = prevCounts.map((count, i) =>
  //       i === index
  //         ? count >= totalProducts
  //           ? STEP
  //           : Math.min(count + STEP, totalProducts)
  //         : count,
  //     );

  //     // Scroll if reducing to STEP
  //     if (prevCounts[index] >= totalProducts) {
  //       const el = document.getElementById(categoryId);
  //       if (el) {
  //         setTimeout(() => {
  //           el.scrollIntoView({ behavior: "smooth", block: "start" });
  //         }, 100); // delay to ensure layout update
  //       }
  //     }

  //     return newCounts;
  //   });
  // };

  // useEffect(() => {
  //   dispatch(getGroupByProduct());

  //   if (location.hash) {
  //     const id = location.hash.replace("#", "");
  //     const el = document.getElementById(id);
  //     if (el) {
  //       el.scrollIntoView({ behavior: "smooth" });
  //     }
  //   }
  // }, [location, dispatch]);

  // useEffect(() => {
  //   dispatch(getGroupByProduct({ p_category_id: categoryId }));
  // }, [dispatch, categoryId]);

  // useEffect(() => {
  //   if (categoryWiseProduct?.data) {
  //     setVisibleCounts(new Array(categoryWiseProduct.data.length).fill(STEP));
  //   }
  // }, [categoryWiseProduct]);

  // useEffect(() => {
  //   const scrollToId = location.state?.scrollToId;
  //   if (scrollToId) {
  //     const scroll = () => {
  //       const element = document.getElementById(scrollToId);
  //       if (element) {
  //         element.scrollIntoView({ behavior: "smooth", block: "start" });
  //       } else {
  //         setTimeout(scroll, 100);
  //       }
  //     };
  //     scroll();
  //   }
  // }, [location.state]);
  // useEffect(() => {
  //   if (!category || category.length === 0) {
  //     setStatus("noCategory");
  //     return;
  //   }

  //   setStatus(""); // category exists

  //   setSelectedCategoryId(category[0].id);

  //   dispatch(getAllSubCategory({ category_id: category[0].id }));
  // }, [category]);

  // useEffect(() => {
  //   if (status === "noCategory") return; // category error already shown

  //   if (!subcategories || subcategories.length === 0) {
  //     setStatus("noSubcategory");
  //     return;
  //   }

  //   setStatus(""); // subcategory exists

  //   dispatch(
  //     getAllProducts({
  //       category_id: selectedCategoryId,
  //       subcategory_id: subcategories?.[0]?.id,
  //     }),
  //   );
  // }, [selectedCategoryId, subcategories]);

  // console.log("selectedCategoryId", selectedCategoryId);

  // useEffect(() => {
  //   if (status === "noCategory" || status === "noSubcategory") return;

  //   if (!all_products?.data || all_products.data.length === 0) {
  //     setStatus("noProducts");
  //     return;
  //   }

  //   setStatus("");
  // }, [all_products]);

  // const [status, setStatus] = useState("");



  return (
    <section className="Categories_section_holder">
      <div className="container">
        <div className="Categories">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          {/* new code for subcategories */}

          <div className="heading_holder">
            <h4 className="heading_text">Category</h4>
          </div>

          <div className="cat_subcat_div">
            {category?.length <= 0 ? (
              <p className="text-danger">No category available.</p>
            ) : (
              <div variant="pills" className="flex-row p-0 mb-3">
                <Swiper
                  className="mySwiper "
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  modules={[Pagination, Navigation]}
                  breakpoints={{
                    0: { slidesPerView: 2, spaceBetween: 5 },
                    320: { slidesPerView: 3, spaceBetween: 5 },
                    486: { slidesPerView: 3, spaceBetween: 10 },
                    576: { slidesPerView: 4, spaceBetween: 10 },
                    768: { slidesPerView: 5, spaceBetween: 10 },
                    992: { slidesPerView: 6, spaceBetween: 10 },
                    1200: { slidesPerView: 8, spaceBetween: 10 },
                  }}
                >
                  {category?.map((slide, index) => {
                    return (
                      <SwiperSlide key={index} className="product-slide">
                        <Nav.Item
                          className={`${Number(selectedCategoryId) === slide?.id
                              ? "activeTab"
                              : ""
                            }`}
                        >
                          <Nav.Link
                            eventKey={slide?.id}
                            onClick={() => {
                              setSelectedCategoryId(slide?.id);
                              handleCategoryClick(slide?.id);
                            }}
                          >
                            <Category_Subcategory_Card
                              className="product-image"
                              content={slide?.name}
                              image={
                                process.env.REACT_APP_IMG_URL + slide?.image
                              }
                              imgClassName="category-image"
                            />
                            <div className="triangle-right"></div>
                          </Nav.Link>
                        </Nav.Item>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            )}
          </div>

          {subcategories?.length <= 0 ? (
            <p className="text-danger">
              No subcategory available for this category.
            </p>
          ) : (
            <>
              <div className="">
                <div className="heading_holder">
                  <h4 className="heading_text">Sub Category</h4>
                </div>
                <div className="cat_subcat_div">
                  <div variant="pills" className="flex-row p-0  mb-3">
                    <Swiper
                      className="mySwiper"
                      onSwiper={(swiper) => setSwiperInstance(swiper)}
                      pagination={{
                        dynamicBullets: true,
                        clickable: true,
                      }}
                      modules={[Pagination, Navigation]}
                      breakpoints={{
                        0: { slidesPerView: 2, spaceBetween: 5 },
                        320: { slidesPerView: 3, spaceBetween: 5 },
                        486: { slidesPerView: 3, spaceBetween: 10 },
                        576: { slidesPerView: 4, spaceBetween: 10 },
                        768: { slidesPerView: 5, spaceBetween: 10 },
                        992: { slidesPerView: 6, spaceBetween: 10 },
                        1200: { slidesPerView: 8, spaceBetween: 10 },
                      }}
                    >
                      {Array.isArray(subcategories) &&
                        subcategories.map((slide, index) => (
                          <SwiperSlide key={index} className="product-slide">
                            <Nav.Item
                              className={`${Number(selectedSubCategoryId) === slide?.id
                                  ? "activeTab"
                                  : ""
                                }`}
                            >
                              <Nav.Link
                                eventKey={slide?.id}
                                onClick={() =>
                                  handleSubCategoryClick(
                                    slide?.p_category_id,
                                    slide?.id,
                                  )
                                }
                              >
                                <Category_Subcategory_Card
                                  className="product-image"
                                  content={slide?.name}
                                  image={
                                    process.env.REACT_APP_IMG_URL + slide?.image
                                  }
                                  imgClassName="category-image"
                                />
                                <div className="triangle-right"></div>
                              </Nav.Link>
                            </Nav.Item>
                          </SwiperSlide>
                        ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </>
          )}

          {all_products?.data?.length <= 0 ? (
            <p className="text-danger">
              No products available for this selection.
            </p>
          ) : (
            <>
              <div className="heading_holder">
                <h4 className="heading_text">All Products</h4>
              </div>

              <div className="row">
                {all_products?.data?.map((product) => (
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col">
                    <Product_Info_Card
                      product={product}
                      id={product.id}
                      imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                      productName={product.name}
                      priceText={product.Product_Variants[0]?.price}
                      kgText={product.Product_Variants[0]?.name}
                      savingPrice={
                        parseFloat(product.Product_Variants[0]?.mrp) -
                        parseFloat(product.Product_Variants[0]?.price)
                      }
                    />
                  </div>
                ))}
              </div>
            </>
          )}

          {/* category_wise_product */}
          {/* <div className="all_cats_div">
            {categoryWiseProduct?.data?.length > 0 ? (
              categoryWiseProduct.data.map((category, index) => (
                <div className="Categories_holder" key={index}>
                  <div id={category.id}>
                    <h4 className="heading_text">{category.name}</h4>
                    <div className="row">
                      {category?.Products?.slice(
                        0,
                        visibleCounts[index] || STEP
                      ).map((product, idx) => (
                        <div
                          className="col-lg-4 col-md-4 col-sm-6 col-6  px-md-2 px-1 custom_5_col"
                          key={idx}
                        >
                          <Product_Info_Card
                            product={product}
                            id={product.id}
                            imgSrc={
                              process.env.REACT_APP_IMG_URL + product.image
                            }
                            productName={product.name}
                            priceText={product.Product_Variants[0]?.price}
                            mrp={product.Product_Variants[0]?.mrp}
                            kgText={product.Product_Variants[0]?.name}
                            savingPrice={
                              parseFloat(
                                product.Product_Variants[0]?.mrp || 0
                              ) -
                              parseFloat(
                                product.Product_Variants[0]?.price || 0
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {category?.Products?.length > STEP && (
                      <div className="see_more_btn_holder">
                        <Green_round_btn
                          btnText={
                            visibleCounts[index] >= category.Products.length
                              ? "See Less"
                              : "See More"
                          }
                          onClick={() =>
                            handleToggle(
                              index,
                              category.Products.length,
                              category.id
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No Category Available</h3>
              </div>
            )}
          </div> */}

          {/* old code */}
          {/* <>
            {categoryWiseProduct?.data?.length > 0 ? (
              categoryWiseProduct.data.map((category, index) => (
                <div className="Categories_holder" key={index}>
                  <div id={category.id}>
                    <Common_Heading_Round_holder headingText={category.name} />
                    <div className="row">
                      {category?.Products?.slice(
                        0,
                        visibleCounts[index] || STEP
                      ).map((product, idx) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-6  px-md-2 px-1"
                          key={idx}
                        >
                          <Product_card
                            product={product}
                            savingPrice={
                              parseFloat(product.Product_Variants[0]?.mrp) -
                              parseFloat(product.Product_Variants[0]?.price)
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {category?.Products?.length > STEP && (
                      <div className="see_more_btn_holder">
                        <Green_round_btn
                          btnText={
                            visibleCounts[index] >= category.Products.length
                              ? "See Less"
                              : "See More"
                          }
                          onClick={() =>
                            handleToggle(
                              index,
                              category.Products.length,
                              category.id
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No Category Available</h3>
              </div>
            )}
          </> */}
        </div>

        {/* <Stay_Connected /> */}
      </div>
    </section>
  );
}

export default Categories;
